<template>
    <div>
        <OPDSpace />
    </div>
</template>

<script>
    import OPDSpace from "./OPDSpace";
    export default {
        name: "OPDSpaceForMobile",
        components:{
            OPDSpace
        }
    }
</script>

<style scoped>

</style>